import { render, staticRenderFns } from "./CreateSliderImage.vue?vue&type=template&id=512bba5b&scoped=true&"
import script from "./CreateSliderImage.vue?vue&type=script&lang=js&"
export * from "./CreateSliderImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512bba5b",
  null
  
)

export default component.exports